export default __webpack_public_path__ + "82c824069bb8e507c55315d22141b034.jpg";